/**
 * RBAC permission slugs for the Exam Hall Ticket module.
 * Keep in sync with backend permissionSeeds.js and route guards.
 */
export const HALL_TICKET_PERMISSIONS = {
  CONFIGURE: "hall_ticket.configure",
  GENERATE: "hall_ticket.generate",
  PUBLISH: "hall_ticket.publish",
  DOWNLOAD: "hall_ticket.download",
};
